<template>
    <!--<button :type="type" :class="[sizeClass]" class="inline-flex items-center justify-center text-white font-semibold tracking-widest hover:bg-red-500 bg-red-600 active:bg-red-600 border border-transparent rounded-md focus:outline-none uppercase transition duration-150 ease-in-out focus:ring-2 focus:ring-red-600 focus:ring-offset-2">-->
    <button
        :disabled="processing || disabled"
        :type="type"
        :class="[{ 'cursor-not-allowed': processing || disabled, 'hover:ring-2': !processing && !disabled, 'group-hover:ring-2': !processing && !disabled, 'cursor-wait': processing }, sizeClass]"
        class="bg-red-600 active:bg-red-600 hover:bg-red-500 text-white focus:shadow-outline-gray focus:ring-red-600 duration-50 relative inline-flex items-center align-middle place-content-center font-semibold tracking-wide border border-transparent rounded-md focus:outline-none uppercase transition ease-in-out focus:ring-4 ring-offset-2"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        focus: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "button",
        },
        size: {
            type: String,
            default: "base",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        sizeClass() {
            if (this.size === "sm") {
                return "py-2 px-5 text-xs"
            }
            return "py-3 px-6 text-sm"
        },
    },

    watch: {
        focus(bool) {
            if (bool) {
                this.$el.focus()
            }
        },
    },
}
</script>
